import core from '@/helpers/client'
const productService = {
  async headProductMasterAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/products`,
      params
    )
    return result
  },
  async getProductMasterListAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/products`,
      params,
      {},
      true
    )
    return result
  },
  async getProductMasterDetailAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/products/${id}`
    )
    return result
  },
  async getProductSEONameAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/products/seo`,
      params
    )
    return result
  },
  async getProductSkuListAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/products/skus`,
      params
    )
    return result
  },
  async getSubstitutesAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/products/skus/substitutes`,
      params
    )
    return result
  },
  async getProductSkuByCodeAsync(sku_code) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/products/skus/${sku_code}`
    )
    return result
  },
  async getProductSkuVendorByCodeAsync(sku_code) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/products/skus/${sku_code}/vendor`
    )
    return result
  },
  async searchProductSkuIncludeProductAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/products/skus/manysearch`,
      model
    )
    return result
  },
  async searchProductSkuStatusAndRemarkIncludeProductAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/products/skus/statusandremark/manysearch`,
      model
    )
    return result
  },

  async getProductSkuListByProductIdAsync(id, params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/products/${id}/skus`,
      params
    )
    return result
  },
  async createProductAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/products`,
      model
    )
    return result
  },
  async createDraftProductRegisterAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/products/draft`,
      model
    )
    return result
  },
  async requestApprovalProductsSkuStatusAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/products/skus/approval/status`,
      model
    )
    return result
  },
  async updateProductMasterAsync(id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/products/${id}`,
      model
    )
    return result
  },
  async deleteProductMasterByIdAsync(id) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/products/delete/${id}`
    )
    return result
  },
  async updateProductSKUVendorAsync(product_id, sku_id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/products/${product_id}/skus/${sku_id}/vendor`,
      model
    )
    return result
  },
  async getProductPriceSkuListByProductIdAsync(id, params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/products/${id}/prices`,
      params
    )
    return result
  },
  async getProductCatalogSkuListByProductIdAsync(id, params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/products/${id}/catalogs`,
      params
    )
    return result
  },
  async getProductInventorySkuListByProductIdAsync(id, params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/products/${id}/inventories`,
      params
    )
    return result
  },
  async editProductApprovalAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/products/approval`,
      model
    )
    return result
  },
  async getProductOFMCompareAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_Lepus}api/v1/ProductSKUs/pim-compare`,
      model,
      {},
      false
    )
    return result
  },
}
export default productService
